import React from "react";
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { APP_COLORS, drawerWidth } from "../../../utils/constants";
import { sections } from "./sections";
import Logo from "./Logo";

export default function MobileDrawer({
  //   container,
  window,
  mobileOpen,
  handleDrawerToggle,
  activeSection,
  handleNavClick,
}) {
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Box sx={{ py: 2, pl: 3, textAlign: "left" }}>
        <Logo handleNavClick={handleNavClick} />
      </Box>

      <Divider />
      <List>
        {sections.map(({ label, id }, i) => (
          <ListItem key={label} disablePadding>
            <ListItemButton
              onClick={() => {
                handleNavClick(id);
              }}
              sx={{
                pl: 3,
                backgroundColor:
                  activeSection === id && APP_COLORS.SECONDARY_BACKGROUND,
                borderRight: `3px solid  ${
                  activeSection === id ? APP_COLORS.MAIN : "transparent"
                }`,
              }}
            >
              <ListItemText primary={label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      {/* <Divider /> */}
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <nav>
      <Drawer
        container={container}
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
      >
        {drawer}
      </Drawer>
    </nav>
  );
}
